import React from "react";
import Navbar from "./navigation";
import "../assets/css/Home.css";
import useDocumentTitle from "./UseDocumentTitle";
import TopHeaderPhoto from "../assets/img/about-us-top-header.jpg";
import WhoWeAre from "../assets/img/who-we-are.jpg";
import OurCommitmentPhoto from "../assets/img/our-commitment.jpg";
import { ReactComponent as ClipBoard } from "../assets/img/clipboard.svg";
import { ReactComponent as Trends } from "../assets/img/trends.svg";
import { ReactComponent as BookCase } from "../assets/img/bookcase.svg";
import { Footer } from "./Home";
import { BookConsultationPopUp } from "./Home";
import { usePanel } from "./PanelContext";
const AboutUs: React.FC = () => {
  const { isOpen } = usePanel();
  useDocumentTitle("About Us", true);
  return (
    <div className="about-us-container">
      <Navbar />
      <AboutUsHeader />
      <AboutUsOurMission />
      <AboutUsWhatWeDo />
      <OurCommitment />
      {isOpen && <BookConsultationPopUp />} {/* ✅ Add this */}
      <Footer />
    </div>
  );
};
const AboutUsHeader: React.FC = () => {
  return (
    <div className="about-us-top-container">
      <div className="about-us-top-header">
        <div className="about-us-wrapper">
          <h1>About Us</h1>
          <div className="about-divider"></div>
          <p>
            At Tax Free Retirement Council, we are dedicated to empowering you
            to achieve a secure, tax-efficient retirement. Our mission is
            simple: to help you navigate the complexities of retirement planning
            with confidence and clarity.
          </p>
        </div>
        <div className="top-header-photo-wrapper">
          <img src={TopHeaderPhoto} />
        </div>
      </div>
    </div>
  );
};

const AboutUsOurMission: React.FC = () => {
  return (
    <div className="our-mission-container">
      <div className="our-mission-row-container">
        <div className="mission-photo-wrapper">
          <img className="" src={WhoWeAre} />
        </div>

        <div className="mission-details-wrapper">
          {" "}
          <h1>Who We Are </h1>
          <div className="about-divider"></div>
          <p>
            We’re a team of experienced retirement planning professionals
            committed to guiding you every step of the way. With a deep
            understanding of tax-free strategies and retirement vehicles, we
            tailor our approach to suit your unique financial goals and
            lifestyle needs.{" "}
          </p>
        </div>
      </div>
    </div>
  );
};

const AboutUsWhatWeDo: React.FC = () => {
  return (
    <div className="what-we-do-container">
      <div className="what-we-do-details-wrapper">
        <div>
          <h1>What We Do</h1>
        </div>

        <div className="about-divider"></div>
        <div className="what-we-do-list-container">
          <ul>
            <li>
              <div className="clipboard-wrapper">
                <ClipBoard className="clipboard-icon" />
              </div>
              <h3>Personalized Planning</h3>
              <p>
                We recognize that every retirement journey is unique. Our
                experts work closely with you to design a comprehensive strategy
                that maximizes your savings and minimizes tax liabilities.
              </p>
            </li>
            <li>
              <div className="trends-wrapper">
                <Trends className="trends-icon" />
              </div>
              <h3>Innovative Strategies</h3>
              <p>
                Staying ahead of ever-changing tax laws and market trends, we
                employ innovative techniques to help you build and preserve
                wealth for a financially secure future.
              </p>
            </li>
            <li>
              <div className="bookcase-wrapper">
                <BookCase className="bookcase-icon" />
              </div>
              <h3>Educational Resources </h3>
              <p>
                We believe in empowering our clients with knowledge. Through our
                blog, webinars, and one-on-one consultations, we provide clear
                insights into the retirement planning process.
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

const OurCommitment: React.FC = () => {
  return (
    <div className="our-commitment-container">
      <div className="our-commitment-header">
        <div className="our-commitment-wrapper">
          <h1>Our Commitment</h1>
          <div className="about-divider"></div>
          <p>
            At Tax Free Retirement Council, your future is our priority. We are
            committed to transparency, integrity, and exceptional service,
            ensuring that you feel supported as you work towards a worry-free
            retirement. Let us help you transform your retirement dreams into
            reality—tax free. Discover how our personalized strategies can help
            you secure a prosperous retirement. Welcome to Tax Free Retirement
            Council, where your future is in safe hands.
          </p>
        </div>
        <div className="our-commitment-photo-wrapper">
          <img src={OurCommitmentPhoto} />
        </div>
      </div>
    </div>
  );
};
export default AboutUs;
